import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import store from "./store";
import "./config";
import { CookiesProvider } from "react-cookie";
import { OidcProvider } from "redux-oidc";
import userManager from "./utils/userManager";
import "./assets/styles.scss";
import RouterComponent from "./components/RouterComponent";
import PrimeReact from "primereact/api";
import { applyLocale, getInitialLocale } from "./i18n";
import I18nProvider from "./i18n/I18nProvider";
// Side-effect import: registers moment's Polish locale before anything formats a date.
import "./i18n/dates";
import "primereact/resources/themes/saga-blue/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import "primeflex/primeflex.css";
import * as Sentry from "@sentry/react";

// Applied before the first render so the user never sees a flash of the wrong language.
applyLocale(getInitialLocale());

PrimeReact.ripple = true;
userManager.clearStaleState();

Sentry.init({
   dsn: window.location.href.includes("localhost")
      ? ""
      : "https://c2e57c1cc90dd47ab9fa0be5800ba262@o1048381.ingest.us.sentry.io/4509281832009728",
   environment: window.location.href.includes("test") ? "test" : "production",
   sendDefaultPii: true,
   tracesSampleRate: 1,
   initialScope: {
      user: {
         username:
            localStorage.getItem("rezydent") ||
            JSON.parse(
               localStorage.getItem(`oidc.user:${window.env.AUTH_URL}:js.panel_rezydenta`) || "{}"
            )?.profile?.name ||
            "Unknown User"
      }
   },
   normalizeDepth: 5,
   ignoreErrors: ["Error: Request failed with status code 401"]
});

ReactDOM.render(
   <Provider store={store}>
      <OidcProvider store={store} userManager={userManager}>
         <CookiesProvider>
            <I18nProvider>
               <RouterComponent></RouterComponent>
            </I18nProvider>
         </CookiesProvider>
      </OidcProvider>
   </Provider>,
   document.getElementById("root")
);
